(function () {
    'use strict';

    angular
        .module('app')
        .controller('ViewFileContentsDialog', ViewFileContentsDialog);

    ViewFileContentsDialog.$inject = ['DialogInstance', 'fileData', 'format'];

    /**
     * @ngdoc controller
     * @name ViewFileContentsDialog
     *
     * @description
     * Dialog for showing the formatted file content.
     * Currently Html and Text formats are supported.
     *
     * @param {string} fileData - The file data which is UTF8 encoded
     * @param {string} format - Format of the file. ('html' or 'txt')
     */
    function ViewFileContentsDialog(DialogInstance, fileData, format) {
        /* jshint validthis:true */
        var vm = this;
        vm.fileString = String.fromCharCode.apply(null, new Uint8Array(fileData));
        vm.format = format;
        vm.close = close;

        function close() {
            DialogInstance.ok();
        }
    }
})();
